import { DatePicker } from '@insight-health-ai/roseate/components';
import dayjs from 'dayjs';
import type { InputProps } from './types';

export function DateInput({ field, value, onChange, autoFocus }: InputProps) {
  return (
    <DatePicker
      value={value ? dayjs(value as string) : null}
      onChange={(_date, dateString) => onChange((dateString as string) || null)}
      className={field.inputClassName}
      disabled={field.disabled}
      autoFocus={autoFocus}
      style={{ width: '100%' }}
    />
  );
}
